define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_platform/validate_fix_api_form",

        validation: {
            name:{
                required: true
            },
            email:{
                required: true,
                pattern: 'email'
            },
            phone_country: {
                required: true,
                pattern: 'number'
            },
            phone_area: {
                required: true,
                pattern: 'number'
            },
            phone_rest: {
                required: true,
                pattern: 'number'
            },
            country: {
                required: true
            },
            captcha_code:{
                required: true
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/uk/main/js/forms/platform/fix_api_form.js
// module id = 63
// module chunks = 0